export default "__VITE_ASSET__Cdr0PO2Z__"